import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  init() {
    gsap.registerPlugin(ScrollTrigger); 
    function setWidhtSticky(){
      const sticky = $(".sticky");
        const parent = sticky.parent();
        sticky.width(parent.width());
    }

    if($('.news-sticky').length) {
      gsap.to('.news-sticky', {
        scrollTrigger : {
          trigger : '.single-news-resource-content',
          start : '250px center',
          end : '95% bottom',
          pin : '.news-sticky'
        }
      });
    }

    if ($(".sticky").length && $(window).width() > 768) {
      const sticky = $(".sticky");
      const navbar = $(".navbar");
      const navbarHeight = navbar.outerHeight(true);
      const extraSpacing = 50;
      const stickyTop = $(".sticky").offset().top;

      const topOnSticky = navbarHeight + extraSpacing;

      // To keep the width when applying fixed position.
      setWidhtSticky();
      const windowW = $(window).width();
      if(windowW >= 1240 ){

        gsap.to('.sticky', {
          scrollTrigger : {
            trigger : '.single-resource-content',
            start : '250px center',
            end : '95% bottom',
            pin : '.sticky',
          }
        })
      } 

      // $(window).on("scroll", () => {
      //   var windowTop = $(window).scrollTop();
      //   const limit = stickyTop - (navbarHeight + extraSpacing);

      //   if (windowTop > limit) {
      //     $(".sticky").css({"position": "fixed", "background" : "red"});
      //     $(".sticky").css("top", topOnSticky);
      //   } else {
      //     $(".sticky").css("position", "relative");
      //   }
      // });

      $(window).on('resize', () => {
        setWidhtSticky();
      })
    }
  },
};
